// extracted by mini-css-extract-plugin
module.exports = {"input":"mxHFD2","form-textarea":"_23ux6A","form-select":"_1Oh5tj","form-multiselect":"_3F1Rwk"};